import type { SubscriptionConfig } from "@repo/ui/lib/api/services/settings.service";
import { PlanSelection } from "../plan-selection";

interface GroupePlanSectionProps {
  subscriptionConfig: SubscriptionConfig;
  selectedPlanType: 'BASIC' | 'ADVANCED';
  selectedTierId: string;
  onPlanSelect: (planType: 'BASIC' | 'ADVANCED', tierId: string) => void;
}

export function GroupePlanSection({
  subscriptionConfig,
  selectedPlanType,
  selectedTierId,
  onPlanSelect
}: GroupePlanSectionProps) {
  return (
    <div className="space-y-4">
      <div>
        <h3 className="text-base font-semibold">Sélection du plan</h3>
        <p className="text-sm text-muted-foreground mt-1">
          Choisissez le plan d'abonnement adapté à vos besoins
        </p>
      </div>

      <PlanSelection
        subscriptionConfig={subscriptionConfig}
        selectedPlanType={selectedPlanType}
        selectedTierId={selectedTierId}
        onPlanSelect={onPlanSelect}
      />
    </div>
  );
}

